// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3SbEV","content":"RecentSearches_content__2dyzj"};